/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PluginFailureRecordFromJSON, PluginFailureRecordToJSON } from './PluginFailureRecord';
/**
 * Check if a given object implements the PluginFailuresRecentResponse interface.
 */
export function instanceOfPluginFailuresRecentResponse(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('reports' in value) || value['reports'] === undefined)
        return false;
    return true;
}
export function PluginFailuresRecentResponseFromJSON(json) {
    return PluginFailuresRecentResponseFromJSONTyped(json, false);
}
export function PluginFailuresRecentResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'reports': (json['reports'].map(PluginFailureRecordFromJSON)),
    };
}
export function PluginFailuresRecentResponseToJSON(json) {
    return PluginFailuresRecentResponseToJSONTyped(json, false);
}
export function PluginFailuresRecentResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'reports': (value['reports'].map(PluginFailureRecordToJSON)),
    };
}
